import React, { useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/Dropdown";
import {
  useAddFolder,
  useFolderParentData,
  useSingleFolderListData,
  useUpdateFolder,
} from "../hooks/useMaterial";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { FaTrash } from "react-icons/fa";
import { handleMedia } from "../../ProductCatalogue/repositories/BrandCampaignRepository";
import { Spinner } from "reactstrap";
import { showToast } from "../../../utils/toastUtils";
interface FolderModalContentProps {
  selectedRow?: any;
  handleClose: () => void;
  editStatus?: string;
  setEditStatus?: any;
  setFormData?: any;
  formData?: any;
  isSubmitting: boolean;
  setIsSubmitting: (val: boolean) => void;
}
const FolderModalContent: React.FC<FolderModalContentProps> = ({
  selectedRow,
  handleClose,
  editStatus,
  setEditStatus,
  setFormData,
  formData,
  isSubmitting,
  setIsSubmitting,
}) => {
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { data: folderParentData } = useFolderParentData({ enable: true });
  const { mutate: addFolder } = useAddFolder();
  const { mutate: updateFolder } = useUpdateFolder();
  const { data: singleFolderListData } = useSingleFolderListData({
    enable: !!selectedRow?.FolderId,
    id: selectedRow?.FolderId,
  });

  const formattedFolderParentData =
    folderParentData?.data?.map((item: any) => ({
      id: item?.FolderId,
      label: item?.FolderName,
    })) || [];

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    if (name === "policyYear") {
      const numericValue = value.replace(/[^0-9]/g, ""); // allow only numbers
      if (numericValue.length <= 4) {
        setFormData((prevState: any) => ({
          ...prevState,
          [name]: numericValue,
        }));
      }
      return;
    }

    // Convert specific fields to numbers
    const numericFields = ["monthlyPotentialSales"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormData((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormData((prev: any) => ({ ...prev, media: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  const handleSubmit = () => {
    if (!formData?.name) {
      showToast?.warning("Please Fill The Folder Name!");
      return;
    } else {
      setIsSubmitting(true);
      const folderBody = {
        FolderName: formData?.name,
        FolderParentId: Number(formData?.parent),
        FolderIcon: formData?.media,
      };

      if (editStatus !== "Update") {
        addFolder(
          { body: folderBody },
          {
            onSuccess: () => {
              setFormData({
                media: "",
                name: "",
                parent: "",
              });
              setEditStatus("");
              handleClose();
              setIsSubmitting(false);
            },
            onSettled: () => {
              setFormData({
                media: "",
                name: "",
                parent: "",
              });
              setEditStatus("");
              handleClose();
              setIsSubmitting(false);
            },
          }
        );
      } else if (singleFolderListData && editStatus === "Update") {
        setIsSubmitting(true);
        updateFolder(
          { id: singleFolderListData?.data?.FolderId, body: folderBody },
          {
            onSuccess: () => {
              setFormData({
                media: "",
                name: "",
                parent: "",
              });
              setEditStatus("");
              setIsSubmitting(false);
              handleClose();
            },
            onSettled: () => {
              setFormData({
                media: "",
                name: "",
                parent: "",
              });
              setEditStatus("");
              handleClose();
              setIsSubmitting(false);
            },
          }
        );
      }
    }
  };

  React.useEffect(() => {
    if (editStatus === "Update" && singleFolderListData?.data) {
      // const parentFolder =

      setFormData({
        media: singleFolderListData?.data?.FolderIcon ?? "",
        name: singleFolderListData?.data?.FolderName ?? "",
        parent: singleFolderListData?.data?.FolderParentId ?? "",
      });
    }
  }, [editStatus, selectedRow, singleFolderListData]);

  return (
    <>
      {!singleFolderListData?.data && editStatus === "Update" ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
        <>
          {/* First Input */}
          <label style={{ fontWeight: "500" }}>
            Folder Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter name"
            value={formData?.name}
            onChange={(e) => handleInputChange("name", e)}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />

          {/* Second Input */}
          <RouteDropdown
            options={formattedFolderParentData || []}
            onChange={(value: any) => {
              handleDropdownSelect("parent", value);
            }}
            DropdownHeading="Parent Folder Name"
            asterisk={true}
            value={formData?.parent}
            placeholder={"Select Parent Folder Name..."}
          />

          {/* Hidden file input */}
          <input
            type="file"
            id="mediaUpload"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          {/* Upload Button or Preview */}
          {formData.media ? (
            <div
              style={{
                position: "relative",
                marginTop: "10px",
                width: "fit-content",
              }}
            >
              <img
                src={
                  formData?.media
                    ? `${BASE_URL}${formData?.media}`
                    : "https://via.placeholder.com/100?text=No+Image"
                }
                alt="preview"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />
              <span
                onClick={() => {
                  setFormData((prevState: any) => ({
                    ...prevState,
                    media: "",
                    mediaFile: null,
                  }));

                  // ✅ Clear input value
                  const fileInput = document.getElementById(
                    "mediaUpload"
                  ) as HTMLInputElement;
                  if (fileInput) fileInput.value = "";
                }}
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-8px",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                  padding: "2px 6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                <FaTrash size={14} color="red" />
              </span>
            </div>
          ) : (
            <Btn
              style={{
                backgroundColor: "#43B9B2",
                color: "white",
                marginTop: "10px",
              }}
              type="button"
              onClick={() => document.getElementById("mediaUpload")?.click()}
            >
              Upload Image
            </Btn>
          )}

          {/* Buttons */}
          <div className="d-flex justify-content-start mt-3 gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {editStatus === "Update" ? "Update" : "Submit"}
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
              onClick={handleClose}
            >
              Cancel
            </Btn>
          </div>
        </>
      )}
    </>
  );
};

export default FolderModalContent;
